import { useEffect, useState } from 'react';

export function useCheckVersion(interval = 30000) {
  const [updateAvailable, setUpdateAvailable] = useState(false);

  useEffect(() => {
    let currentVersion = null;

    async function checkVersion() {
      try {
        const res = await fetch('/version.json?cacheBust=' + Date.now());
        const data = await res.json();

        if (!currentVersion) {
          currentVersion = data.version;
        } else if (currentVersion !== data.version) {
          setUpdateAvailable(true);
        }
      } catch (err) {
        console.error('Version check failed', err);
      }
    }

    checkVersion();
    const intervalId = setInterval(checkVersion, interval);

    return () => clearInterval(intervalId);
  }, [interval]);

  return updateAvailable;
}
